import React, { Component, useCallback, useEffect } from 'react'
import { Container, Jumbotron, Spinner, Form, Button } from 'react-bootstrap'
import { withRouter } from 'react-router-dom'
import { getOptions } from '../Classes/Base'
import Snippet from '../Classes/Snippet'
import Queryset from '../Classes/Queryset'
import { EditorState, RichUtils } from 'draft-js';
import { stateToHTML } from 'draft-js-export-html';
import { stateFromHTML } from 'draft-js-import-html';
import '../css/Editor.css';
import 'draft-js/dist/Draft.css';
import RichTextEditor from '../Components/RichTextEditor';
import { DraftJSexportOptions, DraftJSimportOptions } from '../Helpers/draftHTMLhelpers';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min'
import { Floppy } from 'react-bootstrap-icons'
import MessageCenter from '../Components/MessageCenter'

export default function SnippetDetail(props) {
    const [snippet, setSnippet] = React.useState(null);
    const [editorState, setEditorState] = React.useState(EditorState.createEmpty());
    const [language, setLanguage] = React.useState(undefined);
    const [options, setOptions] = React.useState(null);
    const [changes, setChanges] = React.useState({});
    const [saving, setSaving] = React.useState(false);

    const snippetId = useRouteMatch().params.id

    const setChange = (name, value) => {
        setChanges({ ...changes, [name]: value });
    };

    const getCurrentValue = (name) => {
        return changes[name] !== undefined ? changes[name] : snippet[name];
    };

    const editorStateUpdated = async (editorState) => {
        const lastChange = editorState.getLastChangeType();
        if (lastChange === null) {
            return;
        }
        setEditorState(editorState);
        setChange("body", {
            [language]: stateToHTML(editorState.getCurrentContent(), DraftJSexportOptions)
        });
    };


    const saveChanges = useCallback(async () => {
        setSaving(true);
        console.log("Saving changes", changes);
        const snippet = new Snippet({
            id: snippetId,
            ...changes
        });
        snippet.save()
            .then(() => {
                if (snippet.__status !== 200) {
                    throw new Error(`Chyba při ukládání útržku [${snippet.__status}]: ` + Object.entries(snippetId.__messages || {}).join("\n"));
                }
                setSaving(false);
                setChanges({});
            })
            .catch((error) => {
                setSaving(false);
                MessageCenter.addMessage({ "title": "Chyba při ukládání", "message": "Zkuste to znovu, případně kontaktujte obsluhu. Chyba: " + error.message, "type": "danger" });
            });
    }, [snippetId, changes])

    const loading = Object.entries({
        "Útržek": snippet,
        "Konfigurace": options
    }).filter(([_, value]) => value === null)

    useEffect(() => {
        const queryset = new Queryset(Snippet);
        const fetchSnippet = async () => {
            await queryset.one(snippetId);
            setSnippet(queryset.object);
            const options = await getOptions(Snippet);
            setOptions(options);
            const language = Object.keys(options.actions.POST.body.children)[0];
            setLanguage(language);
        }
        fetchSnippet();
    }, [snippetId])

    useEffect(() => {
        if (snippet == null) {
            return;
        }
        const html = snippet.body[language];
        const contentState = stateFromHTML(html, DraftJSimportOptions);
        const editorState = EditorState.createWithContent(contentState);
        setEditorState(editorState);

    }, [snippet, language]);

    if (loading.length !== 0) {
        return (
            <Container className="mt-4">
                <Jumbotron>
                    <h1>Načítání... </h1>
                    <div>Ještě zbývá: <em>{loading.map(obj => obj[0]).join(", ")}</em></div>
                    <Spinner animation="border" />
                </Jumbotron>
            </Container>
        )
    }

    const topBarExtension =
        <Form.Control
            size='sm'
            as="select"
            value={language}
            onChange={(e) => setLanguage(e.target.value)}
            style={{ width: "150px" }}
        >
            {Object.keys(options.actions.POST.body.children).map(lang => (
                <option key={lang} value={lang}>{lang}</option>
            ))}
        </Form.Control>

    return <Container>
        <Jumbotron>
            <h1>{snippet.title}</h1>
        </Jumbotron>
        <div className="d-flex">
            <Form.Group className="mr-2 flex-grow-1" style={{ minWidth: "200px" }}>
                <Form.Label><strong>Název</strong></Form.Label>
                <Form.Control
                    type="text"
                    value={getCurrentValue("title")}
                    onChange={(e) => setChange("title", e.target.value)}
                    placeholder="Název útržku"
                />
                <Form.Text className="text-muted">
                    Tento název slouží pouze k odlišení jednotlivých útržků v administraci.
                </Form.Text>
            </Form.Group>
        </div>
        <RichTextEditor
            editorState={editorState}
            setEditorState={editorStateUpdated}
            onEditorStateChange={editorStateUpdated}
            topBarExtension={topBarExtension}
        />
        <Form.Group controlId="hook" className='mt-4'>
            <Form.Label className='mb-0'><strong>Zavěšení</strong></Form.Label>
            <Form.Control
                as="select"
                custom
                value={getCurrentValue("hook") || ""}
                onChange={(e) => setChange("hook", e.target.value)}
            >
                {options === null
                    ? <option>Loading...</option>
                    : options.actions.POST.hook.choices.map(i => (
                        <option key={i.value} value={i.value}>{i.display_name}</option>
                    ))
                }
                <option value={""}>Žádný</option>
            </Form.Control>
            <Form.Text className="text-muted">
                Zavěšení definuje místo, kde je obsah použit. Pokud chcete přidat další místa pro zavěšení, kontaktujte prosím podporu.
            </Form.Text>
        </Form.Group>
        {Object.keys(changes).length > 0 && (
            <Button
                className="rounded-circle"
                variant="primary"
                disabled={saving}
                style={{
                    position: "fixed",
                    bottom: "20px",
                    right: "20px",
                    zIndex: 1000
                }}
                onClick={saveChanges}
            >
                {
                    saving
                        ? <Spinner animation="border" size="sm" />
                        : <Floppy />
                }
            </Button>
        )}
    </Container>
}